import useSwr from 'swr'
import { API_URL } from '@/utils/constants'
import Wallet from '@/utils/wallet'
import { NETWORK } from '@/utils/constants'
import useTapBalanceUnified from '@/utils/hooks/useTapBalanceUnified'
import axios from 'axios'
import useRuneBalance from '@/utils/hooks/useRuneBalance'
import useAlkanesBalance from '@/utils/hooks/useAlkanesBalance'

const fetcher = async ([url, address]: any) => {
	if (!address) {
		return []
	}

	try {
		const { data } = await axios.get(`${API_URL}/wallet/${address}${url}`)

		// @ts-ignore
		return data
	} catch {
		return { collections: [] }
	}
}

export default function useBrc20Balance(address?: string): {
	data: any[]
	isLoading: boolean
} {
	const a = address || Wallet.getTaprootAddress()
	const { data: runes } = useRuneBalance(a)
	const { data: alkanes, isLoading: isLoadingAlkanes } = useAlkanesBalance(a)
	const tapBalance = useTapBalanceUnified(a)
	const { data, isLoading } = useSwr(['/brc20-balance', a], fetcher)

	if (NETWORK === 'BTC') {
		if (!data || !Array.isArray(data)) {
			return { data: [], isLoading }
		}

		return {
			data: (Array.isArray(data) ? data : [])
				.concat(tapBalance || [])
				.concat(runes)
				.concat(alkanes),
			isLoading: isLoading || isLoadingAlkanes
		}
	}

	return {
		data: (Array.isArray(data) ? data : []).concat(runes).concat(alkanes),
		isLoading: isLoading || isLoadingAlkanes
	}
}
